export const GridLayout = (props: React.HTMLAttributes<HTMLDivElement>) => {
  return <div {...props} className="t-grid t-grid-cols-[1fr_4fr] t-gap-2" />;
};
